import { Merchant } from "../../../bos_common/src/types/MerchantType";
import { RootState } from "../../store"

export const getMerchant = (state: RootState): Merchant | null => {
  return state.merchant.entities.merchant;
};
